'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["orientation", "hasDividers", "gap"];
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../contexts/EncoreContext.js";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { componentDeprecationWarning } from "../../logging.js";
import { TypeList } from "../TypeList/index.js";
import { ListComponent } from "./List.js";

// TODO: Remove TypeListProps in v7 and rename NextListProps to ListProps.
// Keeping this in v6 since customers are importing ListProps.
// export type ListProps = TypeListProps;

/**
 * Usage of the current List component is deprecated.
 *
 * In order to use the upcoming `List` component, please use [Encore Context](https://encore.spotify.net/web/components/encore-context) to configure `list` to the `next` lifecycle.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-list--docs) |
 * [Encore site](https://encore.spotify.net/web/components/lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/List)
 */
export var List = /*#__PURE__*/React.forwardRef(function List(_ref, ref) {
  var orientation = _ref.orientation,
    hasDividers = _ref.hasDividers,
    gap = _ref.gap,
    props = _objectWithoutProperties(_ref, _excluded);
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.list, config);
  if (status === encoreContextStatus.next) {
    return /*#__PURE__*/React.createElement(ListComponent, Object.assign({
      $orientation: orientation,
      $hasDividers: hasDividers,
      $gap: gap
    }, props, {
      ref: ref,
      "data-encore-id": ENCORE_DATA_IDS.List
    }));
  }
  componentDeprecationWarning('List', 'TypeList', 'v7', 'Pass the "condensedAll" and "listStyleReset" props in order to achieve the same behavior.');
  return /*#__PURE__*/React.createElement(TypeList, Object.assign({
    ref: ref,
    condensedAll: true,
    listStyleReset: 'listStyleReset' in props ? props.listStyleReset : true
  }, props));
});